import { render } from "./OverrideBadge.vue?vue&type=template&id=7e0c4248&scoped=true"
import script from "./OverrideBadge.vue?vue&type=script&lang=js"
export * from "./OverrideBadge.vue?vue&type=script&lang=js"

import "./OverrideBadge.vue?vue&type=style&index=0&id=7e0c4248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0c4248"]])

export default __exports__